import { getSupportEmail, getSupportMailto } from '../lib/support.js'

type Props = {
  /** メールの件名 */
  subject: string
  /** メール本文のテンプレート（任意） */
  body?: string
  /** ボタンのラベル */
  label: string
  /** ボタンの見た目。呼出側の文脈に合わせて渡す */
  className?: string
}

/**
 * 運営への問い合わせ導線。
 *
 * `mailto:` はメールクライアントが登録されていない環境ではクリックしても何も
 * 起きず、ユーザーからは「ボタンが壊れている」ようにしか見えない。特に凍結画面は
 * 運営に連絡する以外に復帰手段が無いため、アドレスを常に画面に出して、
 * メールソフトが開かなくても控えられるようにする。
 */
export function SupportContact({ subject, body, label, className }: Props) {
  const email = getSupportEmail()

  return (
    <div className="space-y-2">
      <a href={getSupportMailto(subject, body)} className={className}>
        {label}
      </a>
      <p className="text-xs text-muted-foreground">
        メールソフトが開かない場合は、こちらのアドレス宛にご連絡ください
        <br />
        <span className="select-all font-medium text-foreground">{email}</span>
      </p>
    </div>
  )
}
